import { render, staticRenderFns } from "./ms-lead-drug.vue?vue&type=template&id=20b594a8&scoped=true"
import script from "./ms-lead-drug.vue?vue&type=script&lang=js"
export * from "./ms-lead-drug.vue?vue&type=script&lang=js"
import style0 from "./ms-lead-drug.vue?vue&type=style&index=0&id=20b594a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b594a8",
  null
  
)

export default component.exports